// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","59":"e8257ea3","137":"76f61abb","288":"77abfc5c","671":"188aceeb","892":"72b8f9bc","937":"f7f5078a","950":"37a6255e"}[chunkId] + ".chunk.js";
};